import { useState, useRef, useEffect } from 'react'
import { useI18n } from '../../i18n'

interface ChordInputProps {
  onAdd: (name: string) => void
  onClose: () => void
}

export function ChordInput({ onAdd, onClose }: ChordInputProps) {
  const { t } = useI18n()
  const [name, setName] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const handleSubmit = () => {
    const trimmed = name.trim()
    if (!trimmed) return
    onAdd(trimmed)
    setName('')
    inputRef.current?.focus()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-end" onClick={onClose}>
      <div
        className="w-full rounded-t-2xl border-t border-surface-lighter bg-surface-light p-4 pb-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto mb-3 h-1 w-10 rounded-full bg-surface-lighter" />
        <div className="flex gap-2">
          <input
            ref={inputRef}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            placeholder={t('songbook.chordName')}
            className="flex-1 rounded-lg border-2 border-surface-lighter bg-surface px-3 py-2.5 text-text placeholder-text-muted focus:border-primary focus:outline-none"
          />
          <button
            className="shrink-0 rounded-lg bg-primary px-4 py-2.5 font-medium text-white active:bg-primary-dark"
            onClick={handleSubmit}
          >
            {t('songbook.add')}
          </button>
        </div>
      </div>
    </div>
  )
}
